<template>
  <b-dropdown class="pointer" :text="this.text" :variant="this.variant" :disabled="this.disabled" :size="this.size" :dropup="this.direction == 'dropup'? true : false" :right="this.listAlign == 'right'? true : false">
    <b-dropdown-item v-if="!(( ignoreAction.includes( option.key))&&(permissionLevel>3.5))" class="pointer" v-for="option in this.options" :href="option.link" :disabled="option.disabled" v-on:click="clicked(option)"><span :class="option.class">{{option.text}}</span></b-dropdown-item>
  </b-dropdown>
</template>
<script type="text/javascript">
/* eslint-disable */
import Vue from 'vue'



export default {
  name: 'FITDropdown',
  props: {
    text: String,
    variant: String,
    disabled: Boolean,
    options: {
      type: Array,
      required: true
    },
    size: String,
    listAlign: {
      type: String,
      default: 'left'
    },
    direction: {
      type: String,
      default: 'dropdown'
    },
  },
  data() {
    return {

      ignoreAction: [
        'delete',
        'renewal',
        'claim',
        'serviceRequest',
        'transferOut',
        'lapse',
        'edit',
      ],

    }
  },
  methods: {
    clicked(item) {
      this.$emit('input', item.text);
      this.$emit('clicked', item.key)
    }
  },
  // mounted(){
  //   let permissionLevel  = this.$store.state.permissionLevel;
  // },
  computed: {
    permissionLevel() {
      return this.$store.state.permissionLevel;
    },
  }
}

</script>



// WEBPACK FOOTER //
// src/components/Button/FITDropdown.vue